import { ResetPasswordComponent } from './../../../public/components/reset-password/reset-password.component';
import { Component, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';
import { Location } from '@angular/common';
import { DashboardProvider } from '../../services';
import { CompanyOwnershipService } from '@app/shared/services/company-ownership.service';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss'],
})
export class DashboardComponent implements OnInit {
  isRestrictedEntity: boolean = false;
  colors = ['#DFF4EB', '#DCF0EB', '#F0EECC', '#F1E6DB', '#F8EBFC'];
  organizationId: string;
  user: any;
  token: string;
  baseUrl = environment.API_SERVER;
  apps: Array<any> = [];
  companyRecord;
  companyDetail;
  loading: boolean = false;
  isBusinessName: boolean = false;
  isRestrictedOfficer: boolean = false;
  constructor(
    private location: Location,
    private dashboardSvc: DashboardProvider,
    private companyOwnershipService: CompanyOwnershipService
  ) {
    const organization = JSON.parse(
      window.localStorage.getItem('organization')
    );
    if (organization.restrictedApplicationId) {
      this.isRestrictedEntity = true;
    }
    this.user = JSON.parse(window.localStorage.getItem('user'));
    if (this.user) {
      this.organizationId = this.user.appUserId;
      this.token = window.localStorage.getItem('jwt');
      let apps: Array<any> = [];
      this.apps = [];
      this.user['applications'].forEach((app) => {
        app['applicationHost'] =
          app['applicationHost'] + '?token=' + this.token;
        apps.push(app);
      });
      this.isRestrictedOfficer = this.user.roleId.roleId === 'CONTRACTOR_ADMIN';
      if (this.isRestrictedEntity) {
        const restrictedApplicationId =
          this.user.organizationId.restrictedApplicationId.applicationId;
        this.apps = apps.filter((item) => {
          return item.applicationId === restrictedApplicationId;
        });
      } else {
        this.apps = apps;
      }
      this.apps.map((app) => {
        app.color = this.generateColors();
      });
      this.getCompanyRecord();
      this.getData();
      this.getAllAfiliateTypes();
      // this.cd.markForCheck();
    }
  }
  allAffiliateTypes;
  getAllAfiliateTypes() {
    this.loading = true;
    this.companyOwnershipService.getOwnershipTypes().subscribe(
      (res: any[]) => {
        this.allAffiliateTypes = res.filter(
          (item) => item.optionName.toLowerCase() === 'proprietor'
        );
        this.allAffiliateTypes = this.allAffiliateTypes[0];
        this.loading = false;
      },
      (error) => {
        console.log(error);
        this.loading = false;
      }
    );
  }
  getCompanyRecord() {
    this.loading = true;
    this.dashboardSvc.getCompanyRecord({}).subscribe(
      (res) => {
        this.companyRecord = res;
        this.loading = false;
      },
      (error) => {
        console.log('Error Occured');
      }
    );
  }
  getData() {
    this.loading = true;
    this.dashboardSvc.getCompanyDetail().subscribe(
      (res) => {
        this.companyDetail = res;
        this.isBusinessName =
          this.companyDetail.companyTypeId.optionId ===
            'business_name_actual' ||
          this.companyDetail.companyTypeId.optionId === 'business_name';
        this.loading = false;
      },
      (error) => {
        this.loading = false;
      }
    );
  }
  generateColors() {
    let color = this.colors[Math.floor(Math.random() * this.colors.length)];
    return color;
  }
  goBack() {
    this.location.back();
  }
  ngOnInit(): void {}
}
